import { render, staticRenderFns } from "./clarificationAndReply.vue?vue&type=template&id=f42a0800&scoped=true"
import script from "./clarificationAndReply.vue?vue&type=script&lang=js"
export * from "./clarificationAndReply.vue?vue&type=script&lang=js"
import style0 from "./clarificationAndReply.vue?vue&type=style&index=0&id=f42a0800&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42a0800",
  null
  
)

export default component.exports